export function createSort(locale) {
    return function sort(a, b) {
        return a.localeCompare(b, locale, {
            caseFirst: 'upper',
            numeric: true,
            sensitivity: 'variant',
        });
    };
}
